import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydModalActions from '../../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../commonDesign/Button'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'
import { provisionedTargets } from '../../../../../../api/integrations'
import { decipherError } from '../../../../../../utils/decipherError'

function EditDetailsForm ({ target, onCancel }) {
  const [description, setDescription] = useState(target?.description || '')
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: modifyTarget } = provisionedTargets.useModifyProvisionedTargetTable()

  const handleSave = useCallback(async () => {
    try {
      setError(null)
      setProcessing(true)
      await modifyTarget({
        provisionedTargetTableId: target.provisionedTargetTableId,
        description: description || null
      })
      onCancel?.()
    } catch (err) {
      setError(decipherError(err))
    } finally {
      setProcessing(false)
    }
  }, [description, modifyTarget, target, onCancel])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SydLabel label='Description'>
          <SydInput
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder='Optional description'
          />
        </SydLabel>
      </Grid>
      <Grid item xs={12}>
        <SydModalActions>
          {error ? <div className='__error'>{error}</div> : null}
          <SydButton disabled={processing} variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton processing={processing} variant='primary' size='md' onClick={handleSave}>
            Save
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

EditDetailsForm.propTypes = {
  target: PropTypes.object,
  onCancel: PropTypes.func
}

export default EditDetailsForm
